'use client'

import Skeleton from 'react-loading-skeleton'

export default function LoyaltyVoucherCardSkeleton() {
  return (
    <div className="loyalty-voucher-card loyalty-voucher-card--skeleton">
      <div className="loyalty-voucher-card__name">
        <Skeleton />
      </div>
      <div className="loyalty-voucher-card__value">
        <Skeleton />
      </div>
      <div className="loyalty-voucher-card__details">
        <Skeleton />
      </div>
      <div className="loyalty-voucher-card__expiry">
        <Skeleton />
      </div>
    </div>
  )
}
